export const DISPERSEABI = {
    sysMainnet: "0x18bE8e35Aed477c5d893cc4819231214Adc02224",
    sysTestnet: "0x4E3f2d5CDa48cFE615C5F3Fee06964Cf9AdD2FF2",
};